import type { RMR } from "epsm-api-types/models";
import type { PriceInfo } from "epsm-api-types/ws";
import type { UTCTimestamp } from "lightweight-charts";
import type { IContext, PineJS } from "@/charting_library/charting_library";
import { RMRIndicatorService } from "./RMRIndicatorService";

export class SectorAndIndexRatioTrendIndicatorService extends RMRIndicatorService {
	fieldMapper(item: RMR): PriceInfo<UTCTimestamp> {
		return {
			time: item.date.getTime() as UTCTimestamp,
			close: item.sector_ratio_trend,
			open: item.index_ratio_trend,
		} as PriceInfo<UTCTimestamp>;
	}

	get requiredFields() {
		return ["sector_ratio_trend", "index_ratio_trend"];
	}

	getPlotsData(PineJS: PineJS, context: IContext): number[] {
		const sector = PineJS.Std.close(context);
		const index = PineJS.Std.open(context);

		return [sector, index];
	}

	get styles() {
		return {
			plot_0: {
				title: "Sector Ratio Trend",
				histogramBase: 0,
			},
			plot_1: {
				title: "Index Ratio Trend",
				histogramBase: 0,
			},
		};
	}
}
